import { lazy, Suspense, useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { triggerHaptic } from "@/utils/haptics";

const MobileNavSheet = lazy(() =>
  import("./MobileNavSheet").then((module) => ({ default: module.MobileNavSheet }))
);

export const MobileNavMenu = () => {
  const [open, setOpen] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);

  const openMenu = () => {
    triggerHaptic("medium");
    setShouldLoad(true);
    setOpen(true);
  };

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
    if (nextOpen) {
      setShouldLoad(true);
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden p-3 h-12 w-12"
        onClick={openMenu}
        aria-label="Öppna meny"
        aria-expanded={open}
        aria-controls={shouldLoad ? "mobile-navigation-menu" : undefined}
      >
        <Menu className="h-7 w-7" />
      </Button>

      {shouldLoad && (
        <Suspense fallback={null}>
          <MobileNavSheet open={open} onOpenChange={handleOpenChange} />
        </Suspense>
      )}
    </>
  );
};
